import React from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box
} from "@mui/material";

import AppButton from "../../ui/AppButton";
import ProjectForm from "./ProjectForm";

function ProjectDialog({
  open,
  project,
  isSaving = false,
  onClose,
  onSave
}) {
  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!isSaving) {
          onClose();
        }
      }}
      disableEscapeKeyDown={isSaving}
      maxWidth={false}
      PaperProps={{
        sx: { width: "90vw", height: "90vh", m: 0, borderRadius: 3, overflow: "hidden" }
      }}
    >
      <DialogTitle
        sx={{
          px: 3,
          pt: 2.5,
          pb: 1.5,
          borderBottom: "1px solid",
          borderColor: "divider"
        }}
      >
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 700,
            color: "text.primary",
            lineHeight: 1.2
          }}
        >
          {project ? "Update Project" : "Create Project"}
        </Typography>

        <Typography
          sx={{
            fontSize: 13,
            color: "text.secondary",
            mt: 0.6
          }}
        >
          Define project details and assign ownership.
        </Typography>
      </DialogTitle>

      <DialogContent
        sx={{
          px: 0,
          py: 0,
          bgcolor: "background.default"
        }}
        dividers
      >
        <Box sx={{ px: 3, py: 2.5, height: "100%" }}>
          <ProjectForm
            project={project}
            onSubmit={onSave}
          />
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          py: 2,
          gap: 1.5,
          borderTop: "1px solid",
          borderColor: "divider"
        }}
      >
        <AppButton variant="outlined" onClick={onClose} disabled={isSaving}>
          Cancel
        </AppButton>

        <AppButton
          variant="contained"
          type="submit"
          form="project-form"
          loading={isSaving}
        >
          {isSaving ? "Saving..." : "Save"}
        </AppButton>
      </DialogActions>
    </Dialog>
  );
}

export default ProjectDialog;
